export const getProcesses = async () => {
  try {
    const requestOptions = {
      method: 'GET',
      redirect: 'follow',
      credentials: 'include',
      //mode: 'cors',
    };

    const response = await fetch(`/api/processes/`, requestOptions)
    return await response.json()
  } catch {
    return [];
  }
}

export const getProcess = async (processId) => {

  const requestOptions = {
    method: 'GET',
    redirect: 'follow',
    credentials: 'include',
    mode: 'cors',
  };

  const response = await fetch(`/api/processes/${processId}/`, requestOptions)
  return await response.json()
}
